/**
 * Imports a JavaScript module from the provided source using
 * the dyanmic `import` function built into browsers.
 * 
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/import
 * 
 * @remarks This logic is split into its own function for the sake
 *  of unit testing other code conaining this logic. The `import` "function"
 *  is not mockable through Jest as it's not technically an object or function.
 *  Rather, it's a keyword according to the MDN link provided above.
 * 
 * @param {string} source URI path for importing a JavaScript module.
 * @returns Promise with the direct result of the `import()` call.
 */
export default async function (source) {
  if (typeof source !== 'string') {
    throw new Error('source must be a string');
  }

  return await import(/* webpackIgnore: true *//* @vite-ignore */ source);
}
